import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { PROJECT } from "@/app/capabilities/permissions";
import {
  connectedUsersSearchDefaults,
  connectedUsersSearchSchema,
  pickFilters,
} from "@/app/oauth/accounts/search";
import { AccountsTable } from "@/app/oauth/accounts/table";
import { connectedAccountsQueryOptions } from "@/app/oauth/api/get-connected-accounts";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/auth/connected-users"
)({
  validateSearch: connectedUsersSearchSchema,
  search: {
    middlewares: [stripSearchParams(connectedUsersSearchDefaults)],
  },
  component: AccountsTable,
  beforeLoad: async (ctx) => {
    await requireProjectPermission(ctx, PROJECT.userConnections.read);
    ctx.context.queryClient.prefetchQuery(
      connectedAccountsQueryOptions({
        scope: ctx.params,
        filters: pickFilters(ctx.search),
        limit: ctx.search.limit,
        offset: ctx.search.offset,
      })
    );
  },
  loader: () => ({
    crumb: "Connected Users",
  }),
});
